import { useI18n } from 'next-localization';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import FundDetailsStripedTable from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsStripedTable';
import useStripedTableHelper from 'hooks/useStripedTableHelper';
import useHelpers from 'hooks/helpers';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import { useFetchFundDetailsBreakdownQuery } from '@/store/fundDetails/services/fundDetailsApi';

type Props = {
  endpoint: string;
  wrapperId?: string;
  titleKey: string;
  tableId?: string;
  minimal?: boolean;
  applyScroll?: boolean;
  showFromToDate?: boolean;
};

const BreakdownHOK = ({
  endpoint,
  minimal = false,
  applyScroll = false,
  showFromToDate = false,
  wrapperId,
  tableId,
  titleKey,
}: Props) => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const { shareClass, language, countryCode, correlationFundRangeId, site, fund } = usePayload();
  const { data, error, isLoading } = useFetchFundDetailsBreakdownQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
      fund,
      endpoint,
    },
    {
      skip: !shareClass,
    }
  );

  const { tableData, reportDate, isScrollable, reportDateFromTo } = useStripedTableHelper(
    data,
    isLoading
  );

  return (
    <div className="mt-5 mt-lg-8">
      <h3>{t(titleKey)}</h3>
      <div className="mt-5">
        {isLoading ? (
          <FundDetailsTabSkeleton />
        ) : error ? (
          <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
        ) : data ? (
          <FundDetailsStripedTable
            reportDate={showFromToDate ? reportDateFromTo : reportDate}
            data={tableData}
            minimal={minimal}
            tableId={tableId}
            wrapperId={wrapperId}
            isScrollable={applyScroll && isScrollable}
          />
        ) : (
          <div className="body-small">{t('noResultsMessage')}</div>
        )}
      </div>
    </div>
  );
};

export default BreakdownHOK;
